module.exports = __webpack_public_path__ + "img/stars.3b1ac3bc.svg";